import { powerupRegistry } from '../powerups/powerup-registry';
/** The six fixed basics, in map order. */
export const HOW_TO_BASICS = ['goal', 'move', 'gates', 'arrows', 'powered', 'moves'];
/**
 * WP-101.7 — the third map group, "Tools & extras", in map order: features
 * around the puzzles rather than rules of the board (SOLVE IT, Undo, Restart,
 * the Daily, coins and tracks), and each counts toward "explored everything" like any other topic.
 */
export const HOW_TO_TOOLS = ['solveIt', 'undoRestart', 'daily', 'coins', 'tracks'];
/**
 * Basics first, then every LIVE power-up in config order (a retired one — the
 * Gate Widener — has no topic: `powerupRegistry` already filters it), then the
 * tools (WP-101.7). This order is the map's and the card sequence's.
 */
export function howToTopics(config, track) {
    const basics = HOW_TO_BASICS.map((id) => ({
        id,
        kind: 'basic',
    }));
    const powerups = powerupRegistry(config, track).map((def) => ({
        id: def.id,
        kind: 'powerup',
    }));
    const tools = HOW_TO_TOOLS.map((id) => ({
        id,
        kind: 'tool',
    }));
    return [...basics, ...powerups, ...tools];
}
/**
 * The topics that count toward the bar, the card sequence and the reward: EVERY
 * topic (WP-101.6; WP-101.10 removed locks altogether). Kept as a function so
 * every caller keeps asking one place.
 */
export function explorableTopics(topics) {
    return [...topics];
}
/** How many explorable topics `seen` covers (a stale id in `seen` counts for nothing). */
export function exploredCount(topics, seen) {
    const have = new Set(seen);
    return explorableTopics(topics).filter((t) => have.has(t.id)).length;
}
/** Every explorable topic has been seen. False for an empty list, never vacuously true. */
export function isAllExplored(topics, seen) {
    const total = explorableTopics(topics).length;
    return total > 0 && exploredCount(topics, seen) === total;
}
